export default __webpack_public_path__ + "static/media/sega_college_logo.5a3c234c.jpeg";